import { getRegisterFunction } from '../../utils/register.js';
import { OneUxPlotChartElement } from './OneUxPlotChartElement.js';
export const register = getRegisterFunction(OneUxPlotChartElement);
declare global {
  interface HTMLElementTagNameMap {
    'one-ux-plot-chart': OneUxPlotChartElement;
    "plot-chart-1722d581cacfdadf014292f1d5308228": OneUxPlotChartElement;
  }
}